import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';

const CompareLink = ({ id, pathName, reviewBadges }) => {
  const { t, linkTo } = useContext(AppContext);

  if (!reviewBadges || reviewBadges.length === 0) {
    return null;
  }

  const { name, sentiment } = reviewBadges[0];

  return (
    <T
      domain="product"
      sentiment={
        <Link to={linkTo('productReviews', { id, pathName })}>
          {t('product', `sentiment-badge.${name}-${sentiment}`)}
        </Link>
      }
    >
      product-info.user-sentiments
    </T>
  );
};

const { arrayOf, shape, number, string } = PropTypes;

CompareLink.propTypes = {
  id: number.isRequired,
  pathName: string.isRequired,
  reviewBadges: arrayOf(
    shape({
      product: shape({
        name: string,
        sentiment: string,
      }),
    })
  ),
};

CompareLink.defaultProps = {
  reviewBadges: undefined,
};

export default CompareLink;
